/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {diplomatObjectSchema} from './diplomat-object';
import {DiplomatObjectType} from './DiplomatObjectType';
import {enums} from './enums';

export const DiplomatAdminUser = diplomatObjectSchema.shape({
   objectType: diplomatObjectSchema.fields.objectType.default(DiplomatObjectType.enum.USER),
   contactName: yup.string().required(),
   role: yup.string().oneOf(enums.role.keys).default(enums.role.enum.USER),
   adminRoleIds: yup.array().of(yup.string()),
   userName: yup.string().required(),
   password: passphrase(),
   lastPasswordUpdate: yup.date(),
   domain: yup.string(),
   userId: yup.idString(),
   twoFactorAuthentication: yup.boolean(),
   ldapPasswordAuthentication: yup.bool(),
   totpRequired: yup.bool(),
});
export type IDiplomatAdminUser = yup.InferType<typeof DiplomatAdminUser>;
